import { MetricOption, TelegramUser } from "../types"

export const METRICS: MetricOption[] = [
  {
    key: "users_count",
    label: "Уникальных регистраций",
    defaultComparator: ">",
    placeholder: "1000",
  },
  {
    key: "new_users_part",
    label: "% новой аудитории",
    defaultComparator: ">",
    unit: "%",
    placeholder: "50",
  },
  {
    key: "user_price",
    label: "Цена уникальной регистрации",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "200",
  },
  {
    key: "orders_creators_price",
    label: "Цена создателя заказа",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "300",
  },
  {
    key: "buyers_price",
    label: "Цена покупателя",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "500",
  },
  {
    key: "web_user_price",
    label: "Цена участника вебинара",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "150",
  },
  {
    key: "ads_clicks_count",
    label: "Кликов",
    defaultComparator: ">",
    placeholder: "1000",
  },
  {
    key: "ads_impressions",
    label: "Показов",
    defaultComparator: ">",
    placeholder: "10000",
  },
  {
    key: "cpc",
    label: "Цена клика, CPC",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "10",
  },
  {
    key: "cpm",
    label: "Цена за 1000 показов, CPM",
    defaultComparator: "<",
    unit: "руб.",
    placeholder: "100",
  },
  {
    key: "ctr",
    label: "CTR объявления",
    defaultComparator: ">",
    unit: "%",
    placeholder: "2",
  },
  {
    key: "ads_click_to_reg_converse",
    label: "Конверсия страницы",
    defaultComparator: ">",
    unit: "%",
    placeholder: "5",
  },
  {
    key: "romi",
    label: "ROMI",
    defaultComparator: ">",
    unit: "%",
    placeholder: "20",
  },
  {
    key: "drr",
    label: "ДРР",
    defaultComparator: "<",
    unit: "%",
    placeholder: "30",
  },
  {
    key: "ads_spend",
    label: "Рекламные расходы",
    defaultComparator: ">",
    unit: "руб.",
    placeholder: "100000",
  },
  {
    key: "profit",
    label: "Прибыль",
    defaultComparator: ">",
    unit: "руб.",
    placeholder: "50000",
  },
  {
    key: "profit_per_user",
    label: "Прибыль на 1 регистрацию",
    defaultComparator: ">",
    unit: "руб.",
    placeholder: "500",
  },
  {
    key: "user_to_web_user_converse",
    label: "Конверсия в доходимость до вебинара",
    defaultComparator: ">",
    unit: "%",
    placeholder: "60",
  },
  {
    key: "user_to_buyer_converse",
    label: "Конверсия из регистрации в покупателя",
    defaultComparator: ">",
    unit: "%",
    placeholder: "10",
  },
  {
    key: "web_users_count",
    label: "Участников вебинара",
    defaultComparator: ">",
    placeholder: "100",
  },
  {
    key: "web_5min_users_part",
    label: "Доля кто был на вебинаре <5 минут",
    defaultComparator: "<",
    unit: "%",
    placeholder: "5",
  },
  {
    key: "web_15min_users_part",
    label: "Доля кто был на вебинаре <15 минут",
    defaultComparator: "<",
    unit: "%",
    placeholder: "10",
  },
  {
    key: "web_60min_g_users_part",
    label: "Доля кто был на вебинаре > 1 часа",
    defaultComparator: ">",
    unit: "%",
    placeholder: "30",
  },
  {
    key: "web_120min_g_users_part",
    label: "Доля кто был на вебинаре > 2 часов",
    defaultComparator: ">",
    unit: "%",
    placeholder: "15",
  },
]

export const MOCK_ACCOUNTS = [
  {
    id: "acc-1",
    name: "Кабинет #1 — Основной рекламный кабинет для продвижения товаров и услуг компании на территории Российской Федерации с фокусом на крупные города и регионы с высокой покупательской способностью",
  },
  {
    id: "acc-2",
    name: "Кабинет #2 — Региональный кабинет для тестирования новых рекламных стратегий и креативов в малых городах и областных центрах с целью последующего масштабирования на федеральный уровень",
  },
  {
    id: "acc-3",
    name: "Кабинет #3 — Тестовый кабинет для экспериментов с различными форматами объявлений, аудиториями и стратегиями ставок перед запуском основных рекламных кампаний в продакшн",
  },
  {
    id: "acc-4",
    name: "Кабинет #4 — E-commerce кабинет специально настроенный для продвижения интернет-магазина с каталогом товаров, динамическими объявлениями и ретаргетингом на посетителей сайта",
  },
]

export const MOCK_USERS: TelegramUser[] = [
  { id: "1", name: "Анна Петрова", username: "annap" },
  { id: "2", name: "Иван Иванов", username: "ivan_ivanov" },
  { id: "3", name: "Мария Смирнова", username: "maria_s" },
  { id: "4", name: "Денис Зубарев", username: "denis_z" },
  { id: "5", name: "Тех. Поддержка", username: "support" },
]

export const MOCK_CAMPAIGNS = [
  {
    id: "c-101",
    name: "Бренд — Поисковая кампания для продвижения брендовых запросов компании с высокими ставками на точные вхождения названия бренда и сопутствующих товаров для максимального охвата целевой аудитории",
  },
  {
    id: "c-102",
    name: "Ремаркетинг — Медийная кампания для возврата посетителей сайта через показ баннерной рекламы на партнерских площадках Яндекса с персонализированными предложениями и скидками",
  },
  {
    id: "c-103",
    name: "Конкуренты — Поисковая кампания по запросам конкурентов для перехвата их трафика с агрессивными ставками и уникальными торговыми предложениями для привлечения клиентов конкурентов",
  },
  {
    id: "c-104",
    name: "Каталог — Смарт-баннеры для автоматического показа товаров из фида с динамическими объявлениями, актуальными ценами и наличием для максимизации конверсии в покупки",
  },
  {
    id: "c-105",
    name: "Лид-формы — Тестовая кампания для сбора контактных данных потенциальных клиентов через встроенные формы в объявлениях с последующей передачей лидов в CRM систему компании",
  },
  {
    id: "c-106",
    name: "Видео — YouTube кампания для продвижения видеоконтента компании с таргетингом на интересы и демографию целевой аудитории для повышения узнаваемости бренда и вовлеченности",
  },
  {
    id: "c-107",
    name: "Акция — Сентябрьская промо-кампания с ограниченным бюджетом и временными рамками для продвижения сезонных товаров и услуг с максимальными скидками для клиентов",
  },
  {
    id: "c-108",
    name: "Ретаргетинг — Карточка товара для показа рекламы пользователям, которые просматривали конкретные товары на сайте, но не совершили покупку, с персонализированными предложениями",
  },
]

export const MOCK_ADGROUPS = [
  { id: "g-201", name: "AG — Бренд / Москва" },
  { id: "g-202", name: "AG — Ремаркетинг / РФ" },
  { id: "g-203", name: "AG — Конкуренты / Поиск" },
  { id: "g-204", name: "AG — Смарт-баннеры / Каталог" },
]

export const MOCK_ADS = [
  { id: "a-301", name: "Текстово-графическое #1" },
  { id: "a-302", name: "Баннер 300x250 — A/B" },
  { id: "a-303", name: "Видео 15с — Brand" },
  { id: "a-304", name: "Смарт-объявление — Товары" },
]
